import * as s from "../ModalTemplateStyled";
import ModalTemplate from "../ModalTemplate";
import styled from "styled-components";
import * as mediaQuery from "components/MediaQuery";
type Props = {
  children?: React.ReactNode;
  style?: React.CSSProperties;
};

const BigPopupNoHeaderTemplate = ({ children, style = {} }: Props) => (
  <ModalTemplate center>
    <Modal style={style}>
      <Inner>{children}</Inner>
    </Modal>
  </ModalTemplate>
);

const Modal = styled(s.Modal)`
  background-color: ${({ theme }) => theme.COLORS.PRIMARY3};
  padding: 10px;

  ${mediaQuery.isMobile} {
    width: 80%;
  }
`;

const Inner = styled(s.Inner)`
  width: 95%;
  position: relative;

  .close-button {
    position: absolute;
    top: 0;
    right: -10px;

    img {
      width: 18px;
    }
  }

  ${mediaQuery.isMobile} {
    .close-button {
      right: 0px;
    }
  }
`;

export default BigPopupNoHeaderTemplate;
